module.exports = __webpack_public_path__ + "img/button-left-minus.c8d62a81.png";